import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService } from '../service/authentication.service';
import { ApiService } from '../service/api.service';
import { UtilService } from '../service/util.service';
import { Constants } from '../constants/constants';
import { ToastService } from '../service/toast.service';
import { Router } from '@angular/router';
import { SearchResultsComponent } from '../search-results/search-results.component';
import { SearchDataService } from '../service/search-data.service';

@Component({
  selector: 'app-fmc-admin-console',
  templateUrl: './fmc-admin-console.component.html',
  styleUrls: ['./fmc-admin-console.component.scss']
})
export class FmcAdminConsoleComponent implements OnInit {

  isAdmin: boolean = false;
  isLogedIn: boolean = false;
  accountCategory: string;
  accountStatus: string;
  isDeveloper: boolean = false;
  isFinanceAdmin: boolean = false;
  
  @ViewChild('searchResult') searchResult: SearchResultsComponent;
  searchedVehicleList: Array<any>;
  searchedLocationList: Array<any>;
  searchedServicePackageList: Array<any>;
  selectedSearchItemForView: string;
  showSearchResult: boolean = false;

  constructor(private apiService: ApiService, public authService: AuthenticationService, public utilService: UtilService, private toast: ToastService, private router: Router, private searchService: SearchDataService) { 
    this.authService.authenticationState.subscribe(state => {
      console.log("logged in user details : ", this.authService.loggedInUser);
      if (state) {
        this.isLogedIn = true;
        //if(this.authService.isAdmin()) {
          //this.isAdmin = true;
        if (this.authService.isUserRoleAllowed()) {
          if (this.authService.isAdmin())
            this.isAdmin = true;
          else if (this.authService.isDeveloper())
            this.isDeveloper = true;
          else if(this.authService.isFinanceAdmin())
            this.isFinanceAdmin = true;
            // this.isAdmin = true;
        } else {
          this.toast.showError("You don't have the permission to access this portal.");
          this.authService.logout();
          this.router.navigate(["/"]);
        }
      } else {
        this.isLogedIn = false;
      }
      console.log("isAdmin::", this.isAdmin)
    });
  }

  ngOnInit() {
    this.accountCategory = this.apiService.accountDetail.category;
    this.accountStatus = this.apiService.accountDetail.status;
    this.showSearchResult = false;
    this.searchService.searchedData.subscribe(data => {
      this.processSearchResult();
    });
  }

  ngOnDestroy() {
    this.searchService.resetPreviousSearchResult();
  }

  private processSearchResult() {

    this.searchedVehicleList = this.searchService.getSearchedDataForType(Constants.VEHICLES);
    this.searchedLocationList = this.searchService.getSearchedDataForType(Constants.LOCATIONS);
    this.searchedServicePackageList = this.searchService.getSearchedDataForType(Constants.SERVICE_PACKAGE);
    this.selectedSearchItemForView = null;
    if ((this.searchedVehicleList && this.searchedVehicleList.length > 0) ||
      (this.searchedLocationList && this.searchedLocationList.length > 0) ||
      (this.searchedServicePackageList && this.searchedServicePackageList.length > 0)) {
      this.showSearchResult = true;
    }
    else {
      this.showSearchResult = false;
    }

  }

}